import {
  GET_DASHBOARD_TIMESHEET_DATA_SUCCESS,
  GET_DASHBOARD_TIMESHEET_DATA_FAILS,
} from "../actionTypes";

const initialState = {
  user: [],
};

const approvalListV2Reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DASHBOARD_TIMESHEET_DATA_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        user: action.payload.user,
      };
    case GET_DASHBOARD_TIMESHEET_DATA_FAILS:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
    default:
      break;
  }

  return state;
};

export default approvalListV2Reducer;
